// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7070a7c483fb774beb4d242608d6f39c99d341e1/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};